/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventnotfounderror3Inputs */

const en_eventnotfounderror3 = /** @type {(inputs: Eventnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event not found.`)
};

const de_eventnotfounderror3 = /** @type {(inputs: Eventnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Event not found." |
*
* @param {Eventnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventnotfounderror3 = /** @type {((inputs?: Eventnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventnotfounderror3(inputs)
	return de_eventnotfounderror3(inputs)
});
export { eventnotfounderror3 as "eventNotFoundError" }